<template>
	<div>
		<el-row>
			<el-col :span="24">
				<div class="bread">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item>个人信息设置与反馈</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :md="12">
				<el-tabs type="border-card" class="user-set">
					<el-tab-pane label="信息修改">
						<el-form v-loading="$store.state.formload" :model="userform" ref="userform" class="demo-form-inline" :label-width="$store.state.width>$store.state.minwidth?'80px':''" :rules="rules">
							<el-form-item label="头 像：" prop="username">
								<el-upload
								  :action="config['apiurl'] + '/api/common/upload'"
								  :show-file-list="false"
								  :on-success="avatarS"
								  :before-upload="avatarBU">
								  <img v-if="userform.avatar" :src="config.apiurl+userform.avatar" class="avatar">
								  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
								</el-upload>
							</el-form-item>
							<el-form-item label="用户名：" prop="username">
								<el-input v-model="userform.username" placeholder="用户名" class="hskd" ></el-input>
							</el-form-item>
							<el-form-item label="昵 称：" prop="nickname">
								<el-input v-model="userform.nickname" placeholder="昵 称" class="hskd" ></el-input>
							</el-form-item>
							<el-form-item label="地 址：" prop="city">
								<el-cascader :options="$store.state.address" v-model="userform.city" placeholder="(未修改)" class="hskd" :props="props"></el-cascader>
							</el-form-item>
							<el-form-item label="公 司：" prop="company">
								<el-input v-model="userform.company" placeholder="公 司" class="hskd" ></el-input>
							</el-form-item>
							<el-form-item label="简 介：" prop="bio">
								<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="userform.bio" class="hskd"></el-input>
							</el-form-item>
							<div style="text-align: center;">
								<el-button type="primary" @click="onSubmit" class="save" >保 存</el-button>
							</div>
						</el-form>
					</el-tab-pane>
					<el-tab-pane label="密码修改">
						<el-form v-loading="$store.state.formload" :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" :label-width="$store.state.width>$store.state.minwidth?'80px':''" class="demo-ruleForm">
							<el-form-item label="旧密码" prop="oldpass">
								<el-input v-model="ruleForm2.oldpass" autocomplete="off"></el-input>
							</el-form-item>
							<el-form-item label="新密码" prop="newpass">
								<el-input v-model="ruleForm2.newpass" autocomplete="new-password" show-password></el-input>
							</el-form-item>
							<el-form-item label="重复密码" prop="checkPass">
								<el-input v-model="ruleForm2.checkPass" autocomplete="new-password" show-password></el-input>
							</el-form-item>
							<div style="text-align: center;">
								<el-button type="primary" @click="submitForm('ruleForm2')">修 改</el-button>
							</div>
						</el-form>
					</el-tab-pane>
					<el-tab-pane label="意见反馈">
						<el-form v-loading="$store.state.formload" :model="opinion" status-icon :rules="opinionrules" ref="opinion" :label-width="$store.state.width>$store.state.minwidth?'80px':''" class="demo-ruleForm">
							<el-form-item label="问题类型" prop="opinionTypeId">
								<el-select v-model="opinionTypeIds" multiple placeholder="请选择" style="width: 100%;">
									<el-option
									  v-for="item in opinionTypeId"
									  :key="item.id"
									  :label="item.name"
									  :value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="问题详情" prop="description">
								<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="opinion.description"></el-input>
							</el-form-item>
							<el-form-item label="相关图片" prop="images">
								<el-upload
								  :action="config.apiurl+'/api/common/upload'"
								  list-type="picture-card"
								  :on-remove="uploadR"
								  :on-success="uploadS"
								  :before-upload="uploadB"
								  ref="flieload">
									<i class="el-icon-plus"></i>
								</el-upload>
							</el-form-item>
							<el-form-item label="联系电话" prop="phone">
								<el-input v-model="opinion.phone" autocomplete="new-password"></el-input>
							</el-form-item>
							<div style="text-align: center;">
								<el-button type="primary" @click="addO()">提 交</el-button>
							</div>
						</el-form>
					</el-tab-pane>
				</el-tabs>
			</el-col>
			<!-- <el-col :md="12">
				<el-tabs tab-position="left" class="about">
					<el-tab-pane label="意见反馈"></el-tab-pane>
					<el-tab-pane label="说明下载"></el-tab-pane>
					<el-tab-pane label="技术支持"></el-tab-pane>
				</el-tabs>
			</el-col> -->
		</el-row>
	</div>
</template>

<script>
	let _this;
	export default {
		data() {
			var validatePass = (rule, value, callback) => {
				if (value == '') {
					callback(new Error('请输入新密码'));
				} else {
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if (value == '') {
					callback(new Error('请再次输入密码'));
				} else if (value != this.ruleForm2.newpass) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			var verifyPhone = (rule, value, callback) => {
				const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/
				if (!reg.test(value)) {
					callback(new Error('请输入正确的电话号码'));
				}
				else {
					callback();
				}
			};
			return {
				userform: {
					avatar: '',
					username: '',
					nickname: '',
					city: [],
					company: '',
					bio: ''
				},
				rules: {
					avatar: [
						{ required: true, message: '请上传头像',	 trigger: 'blur' }
					],
					username: [
						{ required: true, message: '请输入用户名',	 trigger: 'blur' },
						{ min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
					],
					nickname: [
						{ required: true, message: '请输入昵称',	 trigger: 'blur' }
					],
					city: [
						
					],
					company: [
						{ required: true, message: '请输入公司名称',	 trigger: 'blur' }
					],
					bio: []
				},
				props: {
					checkStrictly: true,
					value: 'id',
					label: 'name',
					children: 'children',
					lazy: true,
					lazyLoad (node, resolve) {
						let val=node.path;
						if(_this!=null)
						{
							_this.loadadr(val)
							.then((adr) => {
								resolve(adr);
							});
						}
					}
				},
				ruleForm2: {
					oldpass: '',
					newpass: '',
					checkPass: ''
				},
				rules2: {
					oldpass: [
						{ required: true, message: '请输入旧密码', trigger: 'blur' }
					],
					newpass: [
						{ validator: validatePass, trigger: 'blur' },
						{ min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
					],
					checkPass: [
						{ validator: validatePass2, trigger: 'blur' },
						{ min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
					]
				},
				opinion: {
					opinionTypeId: '',
					description: '',
					images: '',
					phone: ''
				},
				opinionrules: {
					opinionTypeId: [
						
					],
					description: [
						{ required: true, message: '请输入反馈问题', trigger: 'blur' },
						{ min: 10, message: '至少输入 10 个字', trigger: 'blur' }
					],
					phone: [
						{ validator: verifyPhone, trigger: 'blur' }
					]
				},
				opinionTypeId: [],
				images: [],
				opinionTypeIds: []
			}
		},
		methods: {
			avatarS(res, file) {
				this.userform.avatar = res.data.url;
			},
			avatarBU(file) {
				const isJPG = file.type === 'image/jpeg'||file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 2;
			
				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			},
			onSubmit() {
				this.$refs['userform'].validate((valid) => {
					if(valid)
					{
						this.$store.commit('formload',true);
						let value={
							avatar: this.userform.avatar,
							username: this.userform.username,
							nickname: this.userform.nickname,
							city: this.adrtrans(this.userform.city),
							company: this.userform.company,
							bio: this.userform.bio
						}
						this.edituser(value)
						.then((res) => {
							this.$store.commit('formload',false);
							if(res.data.code==1)
								this.$router.back(-1);
						});
					}
				})
			},
			load()
			{
				this.userform.avatar=this.$store.state.main.user.avatar
				this.userform.username=this.$store.state.main.user.username;
				this.userform.nickname=this.$store.state.main.user.nickname;
				this.userform.company=this.$store.state.main.user.company;
				this.userform.bio=this.$store.state.main.user.bio;
				this.getOpiniontype()
				.then((response)=>{
					if(response.data.code==1)
					{
						this.opinionTypeId=response.data.data.list;
					}
				})
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) 
					{
						this.$store.commit('formload',true);
						let value={
							oldPassword: this.ruleForm2.oldpass,
							newPassword: this.ruleForm2.newpass
						};
						this.edituser(value)
						.then((res)=>{
							this.$store.commit('formload',false);
							if(res.data.code==1)
								this.$router.back(-1);
						});
					} 
				});
			},
			addO()
			{
				this.$refs['opinion'].validate((valid) => {
					if (valid) 
					{
						this.$store.commit('formload',true);
						this.opinion.images=this.adrtrans(this.images);
						this.opinion.opinionTypeId=this.adrtrans(this.opinionTypeIds);
						this.addopinion(this.opinion)
						.then((res)=>{
							this.$store.commit('formload',false);
							if(res.data.code==1)
								this.$router.back(-1);
						});
					} 
				});
			},
			uploadS(res, file) {
				this.images.push(res.data.url);
			},
			uploadB(file) {
				const isJPG = file.type === 'image/jpeg'||file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 和 png 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			},
			uploadR(file, fileList) {
				this.images.remove(file.response.data.url);
			}
		},
		mounted: function () {
			_this=this;
			if(this.$store.state.main.user!=null)
			{
				this.load();
			}
		},
		computed: {
			Luser () {
				return this.$store.state.main.user;　　//需要监听的数据
			}
		},
		watch: {
			Luser (newVal, oldVal) {
				this.load();
			}
		}
	}
</script>

<style scoped>
	.about{
		margin-top: 10px;
	}
	.user-set{
		margin-top: 10px;
		box-shadow: none;
	}
	.bread{
		height: 14px;
		padding: 8px 0;
	}
	.hskd{
		width: 100%;
	}
	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 80px;
		height: 80px;
		line-height: 80px;
		text-align: center;
		border: 1px solid #d9d9d9;
	}
	.avatar {
		width: 80px;
		height: 80px;
		border: 1px solid #d9d9d9;
	}
</style>
